import ReactMarkdown from 'react-markdown';
import Form, { renderMonthElement } from '../form/Form';
import { Button, TextArea, Input, Select, Checkbox, Message, Icon } from 'semantic-ui-react';
import { textArea } from '.';
import { habeasData } from './habeasData';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import UploadProfilePhoto from './guests/upload_photo';
import MissingConditionsSummary from '../../containers/groups/newLeaders/MissingConditionsSummary';
import { searchSelectProps } from './forms';

export const renderQuestions = ({
  questions,
  errorInputs = {},
  inputs,
  guests,
  handleInputs,
  handleGuests,
  sending,
  changeStep,
  sendForm,
  errorGuestsInputs,
  setErrorInputs,
  setErrorGuestsInputs,
  //date
  dateFocused,
  set_dateFocused,
  //photo
  set_image,
  image,
}) => {
  const handleInputWithClear = (event) => {
    const name = event?.target?.name;
    handleInputs?.(event);
    if (name && setErrorInputs) {
      setErrorInputs((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleGuestWithClear = (event, person) => {
    const name = event?.target?.name;
    handleGuests?.(event, person);
    if (name && setErrorGuestsInputs) {
      setErrorGuestsInputs((prev) => ({
        ...prev,
        [person]: { ...(prev[person] || {}), [name]: false },
      }));
    }
  };

  return questions.map((question) => {
    if (question.type === 'title') {
      return <h2 className={`${question?.class || ''}`}>{question?.text}</h2>;
    }
    if (question.type === 'text') {
      return <p className={`${question?.class || ''}`}>{question?.text}</p>;
    }
    if (question.type === 'richText') {
      return (
        <div className={`richText ${question?.class || ''}`.trim()}>
          <ReactMarkdown className="line-break">{question?.text}</ReactMarkdown>
        </div>
      );
    }
    if (question.type === 'missingConditions') {
      return (
        <MissingConditionsSummary
          intro={question.intro}
          outro={question.outro}
          items={question.items}
        />
      );
    }
    if (question.type === 'checkbox') {
      return (
        <div className={`${question?.class || ''} checkbox`}>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            htmlFor={question.id}
          >
            {question.text}
          </label>
          {question.options.map((option) => {
            return (
              <Checkbox
                radio={question.radio}
                label={option}
                key={option}
                name={option}
                checked={
                  question.multiple
                    ? Array.isArray(inputs?.[question.id]) && inputs[question.id].includes(option)
                    : inputs?.[question.id] === option
                }
                onChange={() => {
                  if (question.multiple) {
                    const prev = Array.isArray(inputs?.[question.id]) ? inputs[question.id] : [];
                    const newValue = prev.includes(option)
                      ? prev.filter((v) => v !== option)
                      : [...prev, option];
                    handleInputWithClear({
                      target: {
                        name: question.id,
                        value: newValue,
                      },
                    });
                  } else {
                    handleInputWithClear({
                      target: {
                        name: question.id,
                        value: option,
                      },
                    });
                  }
                }}
              />
            );
          })}
        </div>
      );
    }
    if (question.type === 'select') {
      return (
        <div className={`${question?.class || ''}`}>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            htmlFor={question.id}
          >
            {question.text}
          </label>
          <Select
            id={question.id}
            label={question.text}
            placeholder={question.text}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            error={Boolean(errorInputs[question.id])}
            disabled={sending}
            loading={sending}
            {...searchSelectProps({
              name: question.id,
              value: inputs[question.id] ?? '',
              handler: (a, { value }) =>
                handleInputWithClear({
                  target: {
                    name: question.id,
                    value,
                  },
                }),
              options:
                question.optionsObjects ??
                question.options.map((option) => ({
                  key: option,
                  text: option,
                  value: option,
                })),
              selectOnBlur: false,
            })}
          />
        </div>
      );
    }
    if (question.type === 'textArea') {
      return (
        <div className={`${question?.class || ''}`}>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            htmlFor={question.id}
          >
            {question.text}
          </label>
          {textArea({
            TextArea,
            label: question.text,
            name: question.id,
            disabled: sending,
            value: inputs[question.id],
            handler: (event) => handleInputWithClear(event),
            loading: sending,
            errorInputs,
          })}
        </div>
      );
    }
    if (question.type === 'input') {
      return (
        <div className={`${question?.class || ''}`}>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            htmlFor={question.id}
          >
            {question.text}
          </label>
          <Input
            name={question.id}
            placeholder={question.text}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            disabled={sending}
            type={question.kind === 'number' ? 'number' : 'text'}
            min={question.min}
            max={question.max}
            value={inputs[question.id]}
            onChange={(event) => handleInputWithClear(event)}
            loading={sending}
          />
        </div>
      );
    }
    if (question.type === 'date') {
      return (
        <div className={`${question?.class || ''}`}>
          <label
            style={{ display: 'block' }}
            className={`${errorInputs[question.id] ? 'error' : ''}`}
            htmlFor={question.id}
          >
            {question.text}
          </label>
          <SingleDatePicker
            date={
              new Date(inputs[question.id]) === 'Invalid Date' || !inputs[question.id]
                ? null
                : moment(inputs[question.id])
            }
            onDateChange={(newDate) =>
              handleInputWithClear({
                target: {
                  value: newDate ? newDate._d : newDate,
                  name: question.id,
                },
              })
            }
            focused={dateFocused === question.id}
            onFocusChange={({ focused }) => set_dateFocused(focused ? question.id : null)}
            placeholder="dd/mm/aaaa"
            showDefaultInputIcon={true}
            numberOfMonths={1}
            displayFormat="DD/MM/YYYY"
            isOutsideRange={() => false}
            id={question.id}
            renderMonthElement={renderMonthElement}
          />
        </div>
      );
    }
    if (question.type === 'form') {
      return (
        <div className={`${question?.class || ''}`}>
          <h2>{question?.text}</h2>
          <Form
            showGender
            showBirthdate
            Attendant={guests?.guest}
            errorInputs={errorGuestsInputs?.guest}
            handleInputs={(event) => handleGuestWithClear(event, 'guest')}
          />
        </div>
      );
    }
    if (question.type === 'form_male') {
      return (
        <div className={`${question?.class || ''}`}>
          <h2>{question?.text}</h2>
          <Form
            Attendant={guests?.maleGuest}
            showBirthdate
            errorInputs={errorGuestsInputs?.maleGuest}
            handleInputs={(event) => handleGuestWithClear(event, 'maleGuest')}
          />
        </div>
      );
    }
    if (question.type === 'form_female') {
      return (
        <div className={`${question?.class || ''}`}>
          <h2>{question?.text}</h2>
          <Form
            Attendant={guests?.femaleGuest}
            handleInputs={(event) => handleGuestWithClear(event, 'femaleGuest')}
            showBirthdate
            errorInputs={errorGuestsInputs?.femaleGuest}
          />
        </div>
      );
    }
    if (question.type === 'photo') {
      return (
        <div className={`${question?.class || ''}`}>
          <p>{question?.text}</p>
          <UploadProfilePhoto
            name={'image'}
            labelDescription={'foto'}
            imageFile={image}
            filling
            errorInputs={errorInputs}
            inputs={inputs}
            set_image={set_image}
          />
        </div>
      );
    }
    if (question.type === 'habeasData') {
      return <div className={`${question?.class || ''}`}>{habeasData}</div>;
    }
    if (question.type === 'captcha') {
      return null;
    }
    if (question.type === 'prevButton') {
      return (
        <Button
          className={`${question?.class || ''}`}
          onClick={(e) => changeStep(e, 'prev')}
          disabled={sending}
        >
          Volver
        </Button>
      );
    }
    if (question.type === 'nextButton') {
      return (
        <Button
          className={`${question?.class || ''}`}
          onClick={(e) => changeStep(e, 'next')}
          primary
          disabled={sending}
        >
          Siguiente
        </Button>
      );
    }
    if (question.type === 'send') {
      return (
        <>
          {Object.values(errorInputs).includes(true) && (
            <Message error>
              <Icon name="info circle" />
              <Message.Content>
                <Message.Header>Error al guardar las respuestas</Message.Header>
                <p>Por favor, revisa los campos obligatorios.</p>
              </Message.Content>
            </Message>
          )}
          <Button
            className={`${question?.class || ''}`}
            onClick={(e) => sendForm(e)}
            primary
            disabled={sending}
          >
            Enviar
          </Button>
        </>
      );
    }
    return null;
  });
};
